<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12" lg="8">
            <v-text-field
              filled
              data-cy="FormFleetSupplier-name"
              :label="$$t('name')"
              v-model="localFleetSupplier.name"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <v-text-field
              filled
              data-cy="FormFleetSupplier-phone"
              :label="$$t('phone')"
              v-model="localFleetSupplier.phone"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              filled
              rows="3"
              auto-grow
              data-cy="FormFleetSupplier-address"
              :label="$$t('address')"
              v-model="localFleetSupplier.address"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormFleetSupplier-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormFleetSupplier-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormFleetSupplier',
  module: 'Fleet',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    FleetSupplier: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localFleetSupplier
      */
      localFleetSupplier: {},
    };
  },
  watch: {
    FleetSupplier() {
      this.localFleetSupplier = this.FleetSupplier;
    },
  },
  created() {
    this.localFleetSupplier = this.FleetSupplier;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localFleetSupplier);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormFleetSupplier example

'''js
<FormFleetSupplier :FleetSupplier="FleetSupplier" />
'''
</docs>
